
@if (initialdata | async ; as item) {
  <div>
    @if (item.uid=='SeqirusUptakeAcceleratorDetailFirstComp_1' && screenvalue==1) {
      <div class="initialbox">
        <div class="uptakebackbtn" (click)="navigatetolanding()">
          <div class="global_blackarrow"></div>
          <div class="backtext">{{item?.h4content}}</div>
        </div>
        <div class="initialsection">
          <div class="uptakeheader">{{item?.headline}}</div>
          <div class="imagesection">
            <div class="subpageimage"><img [src]="getImage(item?.media.desktop)"></div>
            <div class="sidetext" [innerHtml]="item?.h5content"></div>
          </div>
        </div>
        <div class="initialcont" [innerHtml]="item?.largeparagraphcontent1"></div>
      </div>
    }
    @if (item.uid=='SeqirusUptakeAcceleratorDetailFirstComp_2' && screenvalue==2) {
      <div class="initialbox">
        <div class="uptakebackbtn" (click)="navigatetolanding()">
          <div class="global_blackarrow"></div>
          <div class="backtext">{{item?.h4content}}</div>
        </div>
        <div class="initialsection">
          <div class="uptakeheader">{{item?.headline}}</div>
          <div class="imagesection">
            <div class="subpageimage"><img [src]="getImage(item?.media.desktop)"></div>
            <div class="sidetext" [innerHtml]="item?.h5content"></div>
          </div>
        </div>
        <div class="initialcont" [innerHtml]="item?.largeparagraphcontent1"></div>
      </div>
    }
    @if (item.uid=='SeqirusUptakeAcceleratorDetailFirstComp_3' && screenvalue==3) {
      <div class="initialbox">
        <div class="uptakebackbtn" (click)="navigatetolanding()">
          <div class="global_blackarrow"></div>
          <div class="backtext">{{item?.h4content}}</div>
        </div>
        <div class="initialsection">
          <div class="uptakeheader">{{item?.headline}}</div>
          <div class="imagesection">
            <div class="subpageimage"><img [src]="getImage(item?.media.desktop)"></div>
            <div class="sidetext" [innerHtml]="item?.h5content"></div>
          </div>
        </div>
        <div class="initialcont" [innerHtml]="item?.largeparagraphcontent1"></div>
      </div>
    }
  </div>
}
